import { useEffect } from "react";
import { PublicNav } from "../components/site/PublicNav";
import { PublicFooter } from "../components/site/PublicFooter";

const SECTIONS = [
  {
    title: "1. Who we are",
    body: "SynqSMC operates a society management platform (the \"Service\") consisting of this public website (synqsmc.com) and the SynqSMC ERP application (erp.synqsmc.com). This Privacy Policy explains what information we collect, why, and how we protect it.",
  },
  {
    title: "2. Information we collect",
    body: "Account information: name, email address, phone number, society name and unit details when an account is created for you. Society data: notices, maintenance billing and collection records, complaints and amenity bookings entered by your society's administrators. Contact enquiries: name, email, phone and message submitted through our website forms. Usage data: log data such as IP address, browser type and pages visited, used for security and performance monitoring.",
  },
  {
    title: "3. How we use information",
    body: "We use information to operate and secure the Service, process society billing and communications on behalf of your society, respond to enquiries and demo requests, and improve the product. We do not sell your personal data, and we do not use society or resident data for advertising.",
  },
  {
    title: "4. Who can see your data",
    body: "Data belonging to a society is visible only to that society's authorised administrators and members, and to a limited number of SynqSMC platform administrators who operate the service. We share data with service providers (cloud hosting, email delivery) strictly to operate the Service, under confidentiality obligations.",
  },
  {
    title: "5. Data security",
    body: "Passwords are stored only as bcrypt hashes and are never stored or transmitted in plain text. Sessions use encrypted, httpOnly cookies, and login attempts are rate-limited with temporary lockouts. All traffic is served over HTTPS. No method of transmission is 100% secure, but we follow industry practices to protect your data.",
  },
  {
    title: "6. Data retention and your rights",
    body: "We retain society and account data for as long as the society's subscription is active. You may request access to, correction of, or deletion of your personal data by writing to us. When a society closes its account, its data is deleted or returned on request, subject to legal retention requirements.",
  },
  {
    title: "7. Cookies",
    body: "The ERP application uses strictly necessary cookies for authentication sessions only. This public website does not use advertising or tracking cookies.",
  },
  {
    title: "8. Changes to this policy",
    body: "We may update this Privacy Policy from time to time. Material changes will be announced on this page with an updated effective date.",
  },
  {
    title: "9. Contact & grievance",
    body: "For privacy questions, data requests or grievances, contact us at support@synqsmc.com. We aim to respond within 7 working days.",
  },
];

export default function Privacy() {
  useEffect(() => {
    document.title = "Privacy Policy — SynqSMC";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="privacy-page" className="bg-white">
      <PublicNav />
      <main className="mx-auto max-w-3xl px-5 pb-24 pt-36 sm:px-8">
        <p className="eyebrow mb-4">Legal</p>
        <h1 className="text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl" data-testid="privacy-heading">
          Privacy Policy
        </h1>
        <p className="mt-3 text-sm text-slate-400">Effective date: 14 October 2026</p>
        <div className="mt-10 space-y-8">
          {SECTIONS.map((s) => (
            <section key={s.title}>
              <h2 className="text-lg font-bold text-slate-900">{s.title}</h2>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{s.body}</p>
            </section>
          ))}
        </div>
      </main>
      <PublicFooter />
    </div>
  );
}
